import {
    ORDERFULFILLMENTLIST_REQUEST,
    ORDERFULFILLMENTLIST_SUCCESS,
    ORDERFULFILLMENTLIST_FAILURE,
    ORDERACKNOWLEDGELIST_REQUEST,
    ORDERACKNOWLEDGELIST_SUCCESS,
    ORDERACKNOWLEDGELIST_FAILURE,
    ORDERPICKSLIPLIST_REQUEST,
    ORDERPICKSLIPLIST_SUCCESS,
    ORDERPICKSLIPLIST_FAILURE,
    SUBMITORDERACKNOWLEDGE_REQUEST,
    SUBMITORDERACKNOWLEDGE_SUCCESS,
    SUBMITORDERACKNOWLEDGE_FAILURE,
    PRODUCTDETAILS_REQUEST,
    PRODUCTDETAILS_SUCCESS,
    PRODUCTDETAILS_FAILURE,
    SAVEPACK_REQUEST,
    SAVEPACK_SUCCESS,
    SAVEPACK_FAILURE

    
} from "../constants/ActionTypes";

const initialState = {
    loading: false,
    fowise_details: [],
    summary:[],
    ords : [],
    slip_details : [],
    product_details : [],
    error: null,
};

export default function orderFulfillmentListReducer(state = initialState, action) {

  
    switch (action.type) {
        case ORDERFULFILLMENTLIST_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case ORDERFULFILLMENTLIST_SUCCESS: 
            return {
                
                ...state,
                // always replacing data
                
                fowise_details: action.data.fowise,
                summary:action.data.summary,
                loading: false,
                // if adding data
                // data: [...state.data, action.data]
            };
        case ORDERFULFILLMENTLIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

            //save orderAcknowledge
            case SUBMITORDERACKNOWLEDGE_REQUEST:
                return {
                    ...state,
                    loading: true,
                };
            case SUBMITORDERACKNOWLEDGE_SUCCESS: 
                return {
                    
                    ...state,
                    // always replacing data
                    
                   /*  fowise_details: action.data.fowise,
                    summary:action.data.summary, */
                    loading: false,
                    // if adding data
                    // data: [...state.data, action.data]
                };
            case SUBMITORDERACKNOWLEDGE_FAILURE:
                return {
                    ...state,
                    loading: false,
                    error: action.error,
                };

                //SAVE PACK ORDER
                case SAVEPACK_REQUEST:
                    return {
                        ...state,
                        loading: true,
                    };
                case SAVEPACK_SUCCESS: 
                    return {
                        
                        ...state,
                        // always replacing data
                        
                       /*  fowise_details: action.data.fowise,
                        summary:action.data.summary, */
                        loading: false,
                        // if adding data
                        // data: [...state.data, action.data]
                    };
                case SAVEPACK_FAILURE:
                    return {
                        ...state,
                        loading: false,
                        error: action.error,
                    };
//product details

                case PRODUCTDETAILS_REQUEST:
                    return {
                        ...state,
                        loading: true,
                    };
                case PRODUCTDETAILS_SUCCESS: 
    
                    return {
                        
                        ...state,
                        // always replacing data
                        
                        product_details: action.data.product_details,
                        loading: false,
                        // if adding data
                        // data: [...state.data, action.data]
                    };
    
                case PRODUCTDETAILS_FAILURE:
                    return {
                        ...state,
                        loading: false,
                        error: action.error,
                    };

                    //end product details


            case ORDERACKNOWLEDGELIST_REQUEST:
                return {
                    ...state,
                    loading: true,
                };
            case ORDERACKNOWLEDGELIST_SUCCESS: 

                return {
                    
                    ...state,
                    // always replacing data
                    
                    ords: action.data.order_details,
                    loading: false,
                    // if adding data
                    // data: [...state.data, action.data]
                };

                //ORDER PICKSLIP
            case ORDERACKNOWLEDGELIST_FAILURE:
                return {
                    ...state,
                    loading: false,
                    error: action.error,
                };
                case ORDERPICKSLIPLIST_REQUEST:
                    return {
                        ...state,
                        loading: true,
                    };
                case ORDERPICKSLIPLIST_SUCCESS: 
                    return {
                        
                        ...state,
                        // always replacing data
                        
                        slip_details: action.data.pickslips,
                        loading: false,
                        // if adding data
                        // data: [...state.data, action.data]
                    };
                case ORDERPICKSLIPLIST_FAILURE:
                    return {
                        ...state,
                        loading: false,
                        error: action.error,
                    };
     
        default:
            return state;
    }
}
